import { donorConstants } from "../constants";
import { saveParams, deleteParams, createParams } from "./base.reducers";

const name = "donors";

const initialState = {
  saveLoading: 0,
  saveSuccess: false,
  deleteLoading: 0,
  allLoading: 0,
  startDate: null,
  endDate: null,

  donors: [],
  donorsById: {},
};

export default (state = initialState, payload) => {
  const { type, data } = payload;
  switch (type) {
    // Save and edit donors
    case donorConstants.SAVING_DONOR_REQUEST:
      return {
        ...state,
        saveSuccess: false,
        saveLoading: state.saveLoading + 1,
      };
    case donorConstants.SAVING_DONOR_SUCCESS:
      const { form } = data;
      return {
        ...saveParams({ name, state, form }),
        saveLoading: state.saveLoading - 1,
        saveSuccess: true,
      };
    case donorConstants.SAVING_DONOR_FAILURE:
      return {
        ...state,
        saveLoading: state.saveLoading - 1,
      };
    // Delete donor
    case donorConstants.DELETE_DONOR_REQUEST:
      return {
        ...state,
        deleteLoading: state.deleteLoading + 1,
      };
    case donorConstants.DELETE_DONOR_SUCCESS:
      const id = data;
      return {
        ...deleteParams({ name, state, id }),
        deleteLoading: state.deleteLoading - 1,
      };
    case donorConstants.DELETE_DONOR_FAILURE:
      return {
        ...state,
        deleteLoading: state.deleteLoading + 1,
      };
    // Load donors
    case donorConstants.LOAD_DONORS_REQUEST:
      return {
        ...state,
        allLoading: state.allLoading + 1,
      };
    case donorConstants.LOAD_DONORS_SUCCESS:
      return {
        ...createParams({ name, state, data: data.data }),
        startDate: payload.startDate,
        endDate: payload.endDate,
        allLoading: state.allLoading - 1,
      };
    case donorConstants.LOAD_DONORS_FAILURE:
      return {
        ...state,
        allLoading: state.allLoading - 1,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/donor.reducers.js